<template>
    <div name="rare-disease--calculator" class="wrapper">

        <div class="basic-input" v-if="!isCalculator">
            <select-box-modal 
                :selectList="['센서연동형', '복합폐쇄회로형']"
                :title="'인슐린자동주입기 유형'"
                :selectedIndex="selectedAutoInjector"
                @closeModal="closeModal"
                v-if="isSelectedModalView"
            />
            <img v-if="isBackButtonActive" @click="goHome" style="width: 20px; cursor: pointer;" src="../assets/close_icn.png" class="back-button" />
            <img class="logo" src="../assets/barocare_logo.png" />
            <div class="banner">
                <img class="calc-image" src="../assets/calc.png" />
                <span class="banner-title">자가도뇨카테터 비용 계산기</span>
                <span class="banner-text">간단한 정보로 본인이 부담할 비용을<br>
                    확인할 수 있는 간이 계산기입니다.</span>
            </div>

            <span class="info-text" >기본 정보를 입력해 주세요.</span>
            <text-label 
                :text="'질환 유형'"
                :isDefault="true"
                style="margin-top: 10px;"
            />
            <div class="row" v-if="diseaseType === 'SELF_CATHETER'">
                <img src="../assets/radio_active.png" style="margin-right: 16px;" />
                <span class="text">자가도뇨 카테터 대상자</span>
            </div>
            <div class="row" v-else @click="diseaseType = 'SELF_CATHETER'">
                <img src="../assets/radio_inactive.png" style="margin-right: 16px;width: 22px;" />
                <span class="text">자가도뇨 카테터 대상자</span>    
            </div>          
            
            <div class="info-box">
                <div class="row">
                    <img src="../assets/waring.png" style="margin-right: 8px;"/>
                    <span class="text">참고해 주세요!</span>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="dot"></div>
                    <span class="info-box-text">솔닥에서 취급하는 제품 목록 기준입니다.</span>
                </div>
                <div class="row" style="margin-top: 8px;">
                    <div class="dot"></div>
                    <span class="info-box-text">계산 금액을 상담원에게 전달하시면 확인 후 결제가 진행됩니다.</span>
                </div>
            </div>
            <bottom-button 
                :text="'비용 계산하기'"
                :color="'var(--Gray-100, #1E1E1E)'"
                @onClick="nextStep"
            />
        </div>
        <calculate-result v-else 
            :diseaseType="diseaseType"
            :birth="birth"
            :isAdult="isAdult"
            :autoInjector="autoInjector"
            :selectedAutoInjector="0"
            @back="back"
        />
    </div>
</template>

<script>
import CalculateResult from '@/components/organisms/calculator/catheter/CalculateResult'
import BottomButton from '@/components/atoms/BottomButton';
import PageFooter from '@/components/molecules/PageFooter';
import TextLabel from '@/components/atoms/TextLabel';

import focusBackground from '@/components/directives/focusBackground';

import SelectBoxModal from '@/components/modals/SelectBoxModal';

export default {
    name: 'diabetesCalulator',
    components: {
        CalculateResult,
        BottomButton,
        PageFooter,
        TextLabel,
        SelectBoxModal
    },
    directives: {
        focusBackground
    },
    data: function()
    {
        return {
            isCalculator: false,
            diseaseType: 'SELF_CATHETER',
            birth: null,
            isAdult: true,
            dayOfMonth: 1,
            autoInjector: false,
            selectedAutoInjector: 0,
            isSelectedModalView: false,
            isBackButtonActive: false
        }
    },
    mounted: function()
    {
        if(this.$route.query.isback === 'true')
        {
            this.isBackButtonActive = true;
        }
        ChannelIO('shutdown')
    },
    methods: {
        goHome: function()
        {
            this.$router.push({path: '/home'})
        },
        nextStep: function()
        {
            this.isCalculator = true;
        },
        back: function()
        {
            this.isCalculator = false;
        },
        closeModal: function(index)
        {
            this.selectedAutoInjector = index;
            this.isSelectedModalView = false;
        },
        convertAutoInjector: function(type)
        {
            if(type === 0)
            {
                return '센서연동형'
            }
            else
            {
                return '복합폐쇄회로형'
            }
        },
        modalOpen: function()
        {
            this.isSelectedModalView = true;
        }
    },
    watch: {
        diseaseType: function()
        {
            this.autoInjector = false;
            this.isAdult = true;        
        },
        isAdult: function()
        {
            this.autoInjector = false;
        }
    }
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
    }
    
    .basic-input {
        width: 100%;
        padding: 30px 16px;
        box-sizing: border-box;
        position:relative;
    }

    @media (min-width: 600px) {
        .basic-input {
            width: 600px;            
        }        
    }
    
    .logo {
        width: 94px;

    }
    .banner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        padding: 20px 0px;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        margin-top: 28px;
        margin-bottom: 30px;
        
    }
    .calc-image {
        width: 92px;
    }
    .banner-title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 20px;
    }
    .banner-text {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .info-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 155.556% */
        margin-top: 30px;
    }
    .text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .row {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
    }

    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .info-box {
        width: 100%;
        border-top: 8px solid var(--Gray-sub-color1, #F3F5F8);
        margin-top: 30px;
        padding-bottom: 40px;
        padding-top: 30px; 

    }
    .dot {
        width: 5px;
        height: 5px;
        flex-shrink: 0;
        background: var(--gray-30-stroke, #E8EAEE);
        border-radius: 50%;
        margin-right: 7px;
    }
    .info-box-text {
        color: #6D727A;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
    }
    .selected {
        width: 100%;
        height: 49px;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 23.5px; /* 146.875% */
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px 0 20px;
        margin-top: 16px;
    }
    .bottom-arrow {
        width: 16px;
    }
    .back-button {
        position: absolute;
        right: 16px;
        top: 20px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/page/CatheterCalc.vue